import { HttpHeaders, HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from './../../../environments/environment';
import { Injectable } from '@angular/core';
import { WebsiteStatus } from 'src/app/models/data/website-status';
import { User } from 'src/app/models/data/user.model';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { Page } from 'src/app/models/data/page.model';
import { tap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PageService {
  localUser!: User;
  websiteStatuses = new BehaviorSubject<WebsiteStatus[]>([]);
  pages = new BehaviorSubject<Page[]>([]);

  constructor(private http: HttpClient) { }

  fetchPages(): Observable<Page[]> {
    console.log('📄 PAGE SERVICE DEBUG: Starting fetchPages()');
    this.getUserData();

    console.log('📄 PAGE SERVICE DEBUG: Local user data:', this.localUser);

    if (!this.localUser) {
      console.log('📄 PAGE SERVICE DEBUG: ⚠️ No local user found, returning empty array');
      return of([]);
    }

    let headers = new HttpHeaders({
      token: this.localUser.token,
    });

    console.log('📄 PAGE SERVICE DEBUG: Making API call to:', `${environment.apiUrl}/Page`);
    console.log('📄 PAGE SERVICE DEBUG: Using token:', this.localUser.token ? 'Token present' : 'No token');

    return this.http
      .get<Page[]>(`${environment.apiUrl}/Page`, { headers: headers })
      .pipe(
        tap(pages => {
          console.log('📄 PAGE SERVICE DEBUG: API response received:', pages);
          console.log('📄 PAGE SERVICE DEBUG: Pages count:', pages?.length || 0);
          this.pages.next(pages);
        }),
        catchError((error: HttpErrorResponse) => {
          console.error('📄 PAGE SERVICE DEBUG: ❌ Error fetching pages:', {
            status: error.status,
            statusText: error.statusText,
            url: error.url,
            error: error.error,
            message: error.message
          });
          
          // Log detailed error information
          if (error.error) {
            console.error('📄 PAGE SERVICE DEBUG: Error response body:', error.error);
          }
          
          // Return empty array on error so app can continue with static routes
          this.pages.next([]);
          return of([]);
        })
      );
  }

  fetchWebsiteStatuses(): void {
    this.getUserData();
    if (!this.localUser) return;

    let headers = new HttpHeaders({
      token: this.localUser.token,
    });
    this.http
      .get(`${environment.apiUrl}/Page/WebsiteStatuses`, { headers: headers })
      .subscribe((res) => {
        this.websiteStatuses.next(<WebsiteStatus[]>res);
      });
  }

  getUserData() {
    try {
      const userStr = localStorage.getItem('user');
      if (!userStr) {
        this.localUser = {} as User;
        return;
      }
      const user: {
        username: string;
        token: string;
        status: number;
      } = JSON.parse(userStr);
      this.localUser = user;
    } catch (error) {
      console.error('📄 PAGE SERVICE DEBUG: Error parsing user data from localStorage:', error);
      this.localUser = {} as User;
    }
  }
}
